import * as React from 'react'
import * as _ from 'lodash'
import './DefinitionCard.css'

import { NetworkUser } from 'golgi'
import { standardSCU, arrRemove, arrInsert } from '../util'
import StepProps from './StepProps'
import * as Model from '../types/document'
import { Cursor } from 'src/lib/Cursor';
import { NewDrag, NodeDrag, DefinitionDrag } from 'src/view/drags';
import { DragSourceSpec, DragSourceConnector, DragSourceMonitor, DragSource, DropTargetConnector, DropTargetMonitor, DropTarget, DropTargetSpec } from 'react-dnd';
import { Box, makeBox, setVars, parseConstraintTemplate as kfParse, boxContains, tree } from 'kiwifruit';
import { KiwifruitUser, propsFor, styleFor } from 'kiwifruit-react';
import classNames from 'classnames'

import * as actions from '../actions'
import { arrowSize } from 'src/view/Call';
import { referredOrOwnNodeId } from 'src/model/nodeInfo';
import { canDragFromStackIntoStack, Stack } from 'src/types/stack';
import { definitionById } from 'src/model/document';
import { FixDnd } from 'src/view/DragAndDrop';
import { documentC } from 'src/globals';
import WithContextMenu from 'src/view/WithContextMenu';
import { definitionMenuMaker } from 'src/view/definitionMenuMaker';


interface DefinitionCardProps {
  definitionId: Model.DefinitionId,
  index: number,
}

class DefinitionCard extends React.Component<DefinitionCardProps & ReturnType<typeof dragCollect> & ReturnType<typeof dropCollect>> {
  render() {
    return <NetworkUser debugName="DefinitionCard" props={this.props} state={this.state} render={() => {
      const { definitionId } = this.props
      const { connectDragSource, connectDropTarget, isDragging, canDrop } = this.props

      const definitionC = definitionById(definitionId)
      const domNode = document.querySelector(`[data-definition=${definitionId}]`)
      const name = definitionC._('name').get()
      const hidden = definitionC._('hidden').get()
      const isVisualization = definitionC._('isVisualization').get()

      return <WithContextMenu menuMaker={definitionMenuMaker(definitionC)} divProps={{style: {display: "block"}}}>
        {connectDragSource(connectDropTarget(
          <div
              className={classNames("DefinitionCard", {"font-definition": name})}
              onClick={() => domNode && domNode.scrollIntoView()}
              onMouseMove={() => domNode && !isDragging && !canDrop && domNode.classList.add('Highlight')}
              onMouseOut={() => domNode && domNode.classList.remove('Highlight')}
              style={{opacity: isDragging ? 0 : 1}}
            >
            <img
              className={classNames("DefinitionCard-visibility-icon", {"DefinitionCard-visibility-icon-hidden": hidden})}
              src={hidden ? "images/no-eye.svg" : "images/eye.svg"}
              onClick={() => actions.act(() => {
                definitionC._('hidden').set(!hidden)
              })}
            />
            {name || "[blank]"}
            <span className={classNames("DefinitionCard-visualization-icon", {"DefinitionCard-visualization-icon-visible": isVisualization})}>
              📊
            </span>
          </div>
        ))}
      </WithContextMenu>
    }}/>
  }
}

const dropSpec: DropTargetSpec<DefinitionCardProps> = {
  canDrop(props, monitor) {
    return true
  },

  hover(props: DefinitionCardProps, monitor: DropTargetMonitor) {
		const definitionDrag = monitor.getItem() as DefinitionDrag
		
		if (definitionDrag.definitionId !== props.definitionId) {
      moveDefinition(definitionDrag.definitionId, props.index)
      requestAnimationFrame(() => {
        const domNode = document.querySelector(`[data-definition=${definitionDrag.definitionId}]`)
        if (domNode) { domNode.scrollIntoView() }
      })
		}
	},
}

function dropCollect(connect: DropTargetConnector, monitor: DropTargetMonitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop(),
  };
}


const dragSpec: DragSourceSpec<DefinitionCardProps, DefinitionDrag> = {
  beginDrag(props) {
    return {
      type: 'definition',
      definitionId: props.definitionId,
      initialIndex: props.index,
    }
  },

  endDrag(props: DefinitionCardProps, monitor: DragSourceMonitor) {
		const definitionDrag = monitor.getItem() as DefinitionDrag

		if (!monitor.didDrop()) {
			moveDefinition(definitionDrag.definitionId, definitionDrag.initialIndex)
		}
	},
}

function dragCollect(connect: DragSourceConnector, monitor: DragSourceMonitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  };
}

function moveDefinition(definitionId: Model.DefinitionId, index: number) {actions.act(() => {
  documentC._('definitions').update((definitions) => {
    const toMove = definitionById(definitionId).get()
    const removeOld = _.without(definitions, toMove)
    const insertNew = arrInsert(removeOld, index, toMove)
    return insertNew
  })
})}

export default (
  FixDnd(
    DragSource("definition", dragSpec, dragCollect, {arePropsEqual: () => false})(
      DropTarget(["definition"], dropSpec, dropCollect, {arePropsEqual: () => false})(
        DefinitionCard))))



// WEBPACK FOOTER //
// ./src/view/DefinitionCard.tsx